module.exports = __webpack_public_path__ + "static/stripes-8cb0a30465c389aed2ac9f97415b0e21.jpg";